import {
  AddressInput,
  AddressRow,
  CreateAddress,
  UpdateAddress,
} from "./address.type";
import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";

export async function listAddresses(): Promise<AddressRow[]> {
  const slug = ApiEndpoints.address + "/";
  const options = await setHeaderOptions({ method: "GET" });
  return fetchData<AddressRow[]>(slug, options);
}

export async function getUsersAddress(userId: string): Promise<AddressRow> {
  const slug = `${ApiEndpoints.address}/user/${encodeURIComponent(userId)}`;
  const options = await setHeaderOptions({ method: "GET" });
  return fetchData<AddressRow>(slug, options);
}

export async function getAddress(id: string): Promise<AddressRow> {
  const slug = `${ApiEndpoints.address}/${encodeURIComponent(id)}`;
  const options = await setHeaderOptions({ method: "GET" });
  return fetchData<AddressRow>(slug, options);
}

export async function createAddress(body: CreateAddress): Promise<AddressRow> {
  const slug = ApiEndpoints.address + "/";
  const options = await setHeaderOptions({ method: "POST", body });
  return fetchData<AddressRow>(slug, options);
}

export async function updateAddress(
  id: string,
  body: Omit<UpdateAddress, "id">
): Promise<AddressRow> {
  const slug = `${ApiEndpoints.address}/${encodeURIComponent(id)}`;
  const options = await setHeaderOptions({ method: "PUT", body });
  return fetchData<AddressRow>(slug, options);
}

export async function deleteAddress(id: string): Promise<void> {
  const slug = `${ApiEndpoints.address}/${encodeURIComponent(id)}`;
  const options = await setHeaderOptions({ method: "DELETE" });
  return fetchData<void>(slug, options);
}

export async function unlinkInstitutionAddress(
  institutionId: string
): Promise<void> {
  const slug = `${ApiEndpoints.address}/institution/${encodeURIComponent(
    institutionId
  )}`;
  const options = await setHeaderOptions({ method: "DELETE" });
  return fetchData<void>(slug, options);
}

export async function unlinkProviderAddress(
  providerId: string
): Promise<void> {
  const slug = `${ApiEndpoints.address}/provider/${encodeURIComponent(
    providerId
  )}`;
  const options = await setHeaderOptions({ method: "DELETE" });
  return fetchData<void>(slug, options);
}

export async function hardDeleteAddress(id: string): Promise<void> {
  const slug = `${ApiEndpoints.address}/${encodeURIComponent(id)}/hard`;
  const options = await setHeaderOptions({ method: "DELETE" });
  return fetchData<void>(slug, options);
}

// Institution-linked addresses
export async function getInstitutionAddress(
  institutionId: string
): Promise<AddressRow | null> {
  const slug = `${ApiEndpoints.address}/institution/${encodeURIComponent(
    institutionId
  )}`;
  const options = await setHeaderOptions({ method: "GET" });
  return fetchData<AddressRow | null>(slug, options);
}

export async function createInstitutionAddress(
  institutionId: string,
  body: AddressInput
): Promise<AddressRow> {
  const slug = `${ApiEndpoints.address}/institution/${encodeURIComponent(
    institutionId
  )}`;
  const options = await setHeaderOptions({ method: "POST", body });
  return fetchData<AddressRow>(slug, options);
}

export async function updateInstitutionAddress(
  institutionId: string,
  body: AddressInput
): Promise<AddressRow> {
  const slug = `${ApiEndpoints.address}/institution/${encodeURIComponent(
    institutionId
  )}`;
  const options = await setHeaderOptions({ method: "PUT", body });
  return fetchData<AddressRow>(slug, options);
}

// Provider-linked addresses
export async function getProviderAddress(
  providerId: string
): Promise<AddressRow | null> {
  const slug = `${ApiEndpoints.address}/provider/${encodeURIComponent(
    providerId
  )}`;
  const options = await setHeaderOptions({ method: "GET" });
  return fetchData<AddressRow | null>(slug, options);
}

export async function createProviderAddress(
  providerId: string,
  body: AddressInput
): Promise<AddressRow> {
  const slug = `${ApiEndpoints.address}/provider/${encodeURIComponent(
    providerId
  )}`;
  const options = await setHeaderOptions({ method: "POST", body });
  return fetchData<AddressRow>(slug, options);
}

export async function updateProviderAddress(
  providerId: string,
  body: AddressInput
): Promise<AddressRow> {
  const slug = `${ApiEndpoints.address}/provider/${encodeURIComponent(
    providerId
  )}`;
  const options = await setHeaderOptions({ method: "PUT", body });
  return fetchData<AddressRow>(slug, options);
}
